/**
 * The priority a report was actually filed at, on the confirmation (20 Oct).
 *
 * From the server's answer (`TicketDetail.priority_code`), so the Emergency
 * form and the suspicious email page never promise a priority the ticket does
 * not have. Shows nothing when the server did not say.
 */

import { Typography } from "@norican/react";

import { useT } from "@/i18n";

import { filedPriorityNumber } from "./lib/priority";

export function FiledPriority({ code }: { code: string | null | undefined }) {
  const { t } = useT("tickets");
  const number = filedPriorityNumber(code);
  if (number === null) {
    return null;
  }
  return (
    <Typography as="p" variant="body-sm" className="font-medium">
      {t("emergency.filedPriority", { number })}
    </Typography>
  );
}
